<template>
<div class="article-style-h2">
    <div class="content-container" :class="[pageConfigLayoutStyle?.ARTICLE_PAGE_WIDE_LAYOUT === pageLayoutStyle ? 'article-style-h2-wide':'article-style-h2-narrow']">
        <h2 :class="[widgetConfig.BodyText || widgetConfig.H2ShowRedUnderline ? 'pb-3' : 'pb-0']">{{ widgetConfig.H2Text }}</h2>

        <div v-if="widgetConfig.H2ShowRedUnderline" class="red-bar"></div>

        <p v-if="widgetConfig.BodyText" class="p-0 content-block" v-html="widgetConfig.BodyText"></p>
    </div>
    
    <div :class="{ 'has-border-bottom': widgetConfig.EnableSeparator }"></div>
</div>
</template>

<script>
export default {
    name: "ArticleStyleH2",
    props: {
        widgetConfig: Object,
        pageLayoutStyle: String
    }
}
</script>

<style lang="scss" scoped>
.article-style-h2 {
    
    margin: auto;

    .article-style-h2-narrow {
        max-width: $narrower-page-width-padded;
    }

     .article-style-h2-wide {
        max-width: $page-width-padded;
    }

    .content-container {
        .red-bar {
                width: 120px;
                height: 5px;
                background-color: $red;
                margin-top: $spacer-three;

            +p {
                margin-top: $spacer-six;
            }
        }
    }

    .has-border-bottom {
        height: 1px;
        background-color: $grayscale-five;
        margin: $spacer-six $page-padding 0;
    }

    @include tablet {
        .content-container {
            margin: 0 $page-padding;
            padding: $spacer-six 0 0;
        }

    }

    @include wide-mobile {
        .content-container {
            margin: 0 $page-padding;
            padding: 40px 0 0;
        }
    }
}
</style>
